<template>
  <section id="hospital-settings" class="case-creation" v-loading="loading">
    <div
      v-if="getSingleSetting"
      key=""
      class="case-creation__step case-creation__patient-information"
    >
      <!-- View Hospital settings -->
      <div class="vue-form">
        <div class="case-creation__card">
          <div
            class="case-creation__body"
            v-if="getSingleSetting && status == 'view'"
          >
            <div class="">
              <el-button class="edit-btn" @click="editStatus">
                <span class="edit-icon">
                  <img
                    src="@/assets/images/icons/edit-case-information.svg"
                    alt=""
                  />

                  EDIT
                </span>
              </el-button>
            </div>

            <el-row>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Auto Fax</h4>
                  <p>{{ settingsInfo.auto_fax ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Email Notification</h4>
                  <p>{{ settingsInfo.email_notifications ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Requires Inhouse Phlebotomist</h4>
                  <p>
                    {{ settingsInfo.requires_inhouse_phlebotomist ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Daily Statistics</h4>
                  <p>{{ settingsInfo.daily_statistics ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Sample Collection Type</h4>
                  <p>{{ formatCollectionType(settingsInfo.sample_collection_type) }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Daily Sample Pickup</h4>
                  <p>{{ settingsInfo.is_daily_sample_pickup ? "Yes" : "No" }}</p>
                </div>
              </el-col>
            </el-row>

            <el-row v-if="settingsInfo.is_daily_sample_pickup">
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup Days</h4>
                  <p>{{ (settingsInfo.pickup_days || []).join(", ") || "-" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup Time</h4>
                  <p>{{ settingsInfo.pickup_time || "-" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup Address</h4>
                  <p>{{ settingsInfo.pickup_address || "-" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup Zip</h4>
                  <p>{{ settingsInfo.pickup_zip || "-" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup City</h4>
                  <p>{{ settingsInfo.pickup_city || "-" }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="input-value">
                  <h4 class="name">Pickup State</h4>
                  <p>{{ settingsInfo.pickup_state || "-" }}</p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div v-if="getSingleSetting && status == 'edit'">
            <div class="case-creation__body pb-0">
              <div class="vue-form">
                <el-form :model="form">
                  <el-row :gutter="30">
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="Auto Fax"
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.auto_fax"
                            />
                            <label for="text" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.auto_fax"
                            />
                            <label for="text">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="
                        Email Notification

                          "
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.email_notifications"
                            />
                            <label for="notifications" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.email_notifications"
                            />
                            <label for="notificaions">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="
                        Requires Inhouse Phlebotomist

                          "
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.requires_inhouse_phlebotomist"
                            />
                            <label for="phlebotomist" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.requires_inhouse_phlebotomist"
                            />
                            <label for="phlebotomist">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="
                       Daily Statistics

                          "
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.daily_statistics"
                            />
                            <label for="notifications" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.daily_statistics"
                            />
                            <label for="notificaions">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30">
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="Sample Collection Type"
                          :required="true"
                        >
                          <div class="form-group">
                            <el-radio v-model="form.sample_collection_type" value="HOME" label="HOME">Home</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="INCLINIC" label="INCLINIC">In Clinic</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="BOTH" label="BOTH">Both</el-radio>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item
                          class="name"
                          label="Daily Sample Pickup"
                          :required="true"
                        >
                          <div class="form-group">
                            <input
                              type="radio"
                              v-bind:value="true"
                              v-model="form.is_daily_sample_pickup"
                            />
                            <label for="text" class="mr-30">Yes</label>
                            <input
                              type="radio"
                              v-bind:value="false"
                              v-model="form.is_daily_sample_pickup"
                            />
                            <label for="text">No</label>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30" v-if="form.is_daily_sample_pickup">
                    <el-col :span="16">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup Days">
                          <el-checkbox-group v-model="form.pickup_days" style="display: flex; flex-wrap: wrap; gap: 10px;">
                            <el-checkbox
                              v-for="day in ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                              :key="day"
                              :label="day"
                            >{{ day }}</el-checkbox>
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup Time">
                          <el-input v-model="form.pickup_time" placeholder="Enter pickup time (e.g. 09:00 AM)"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30" v-if="form.is_daily_sample_pickup">
                    <el-col :span="24">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup Address">
                          <el-input v-model="form.pickup_address" placeholder="Enter pickup address"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30" v-if="form.is_daily_sample_pickup">
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup Zip">
                          <el-input v-model="form.pickup_zip" maxlength="5" placeholder="Zip"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup City">
                          <el-input v-model="form.pickup_city" placeholder="City"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="input-value">
                        <el-form-item class="name" label="Pickup State">
                          <el-input v-model="form.pickup_state" placeholder="State"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>

        <div
          class="case-creation__actions"
          v-if="getSingleSetting && status == 'edit'"
        >
          <ul class="list">
            <li>
              <el-button
                size="medium"
                type="default"
                class="btn cancel-button"
                @click="cancelSettingDetails"
                >Cancel</el-button
              >
            </li>
            <li>
              <el-button
                size="medium"
                type="success"
                class="btn save-button"
                @click="submitSettingDetails"
                >Save</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      status: "view",
      form: {
        auto_fax: false,
        email_notifications: false,
        requires_inhouse_phlebotomist: false,
        daily_statistics: false,
        sample_collection_type: "",
        is_daily_sample_pickup: false,
        pickup_time: "",
        pickup_days: [],
        pickup_address: "",
        pickup_zip: "",
        pickup_city: "",
        pickup_state: "",
      },
      settingsInfo: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters("branches", [
      "getSingleSetting",
      "getBranchValidationErrors",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
  },
  async mounted() {
    this.fetchSettings();
    this.goToSettings();
  },
  methods: {
    editStatus() {
      this.status = "edit";
    },
    formatCollectionType(value) {
      if (value === "HOME") return "Home";
      if (value === "INCLINIC") return "In Clinic";
      if (value === "BOTH") return "Both";
      return "-";
    },
    async fetchSettings() {
      this.loading = true;
      let params = {
        hospital_id: this.hospital_id,
      };
      await this.$store.dispatch("branches/getHospitalSettings", params);
      this.loading = false;
      this.settingsInfo = JSON.parse(JSON.stringify(this.getSingleSetting));
      this.settingsInfo.daily_statistics =
        this.settingsInfo.daily_statistics || false;
      this.form.auto_fax = this.settingsInfo.auto_fax;
      this.form.email_notifications = this.settingsInfo.email_notifications;
      this.form.requires_inhouse_phlebotomist =
        this.settingsInfo.requires_inhouse_phlebotomist || false;
      this.form.daily_statistics = this.settingsInfo.daily_statistics;
      this.form.sample_collection_type =
        this.settingsInfo.sample_collection_type || "";
      this.form.is_daily_sample_pickup =
        this.settingsInfo.is_daily_sample_pickup || false;
      this.form.pickup_time = this.settingsInfo.pickup_time || "";
      this.form.pickup_days = this.settingsInfo.pickup_days || [];
      this.form.pickup_address = this.settingsInfo.pickup_address || "";
      this.form.pickup_zip = this.settingsInfo.pickup_zip || "";
      this.form.pickup_city = this.settingsInfo.pickup_city || "";
      this.form.pickup_state = this.settingsInfo.pickup_state || "";
    },
    async goToSettings() {
      this.status = "view";
      this.fetchSettings();
    },
    async submitSettingDetails() {
      let params = {
        hospital_id: this.hospital_id,
        params: this.form,
      };
      await this.$store.dispatch("branches/updateHospitalSettings", params);

      if (this.getSettingsAddStatus) {
        successNotification("settings Updated successfully");
        this.goToSettings();
      } else if (!this.getBranchValidationErrors) {
        errorNotification("Error while updating settings");
      }
    },

    cancelSettingDetails() {
      if (Object.keys(this.form).length === 0) {
        this.clearSettingsAndGoToSettings();
      } else {
        this.$confirm("Are you sure to cancel Update Settings?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.clearSettingsAndGoToSettings();
        });
      }
    },
    clearSettingsAndGoToSettings() {
      (this.form = {}), this.goToSettings();
    },
  },
};
</script>

<style lang="scss"></style>
